"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Settings = Settings;
const React = __importStar(require("react"));
const react_jss_1 = require("react-jss");
const plugins_1 = require("~/plugins");
const settings_1 = require("~/settings");
const quitGameButton_1 = require("./quitGameButton");
const useStyles = (0, react_jss_1.createUseStyles)({
    settings: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
    },
    row: {
        fontSize: "16px",
    },
});
function Settings() {
    const styles = useStyles();
    const showPing = (0, settings_1.useSetting)("showPing");
    const setShowPing = (0, settings_1.useSetSetting)("showPing");
    return (React.createElement(plugins_1.Region, { cls: "settings-section", id: "settings.root", ctx: {} },
        React.createElement("div", { className: styles.settings },
            React.createElement("div", null,
                React.createElement(quitGameButton_1.QuitGameButton, null)),
            React.createElement("div", null,
                React.createElement("input", { type: "checkbox", checked: showPing, onChange: () => setShowPing(!showPing) }),
                React.createElement("label", null, "Show ping")))));
}
